import { CubeTransparentIcon } from '@heroicons/react/24/solid'
import { useState } from 'react'
import styled from 'styled-components'
import Tooltip from '../../../../UI/Tooltip/Tooltip'
import { useSelector } from 'react-redux'
import props from '../../../../../redux/props'
import { functional } from '@think-internet/zeus-frontend-package'
import Routes from '../../../../../redux/routes'
import useToast, { Type } from '../../../../hooks/useToast'

const Icon = styled(CubeTransparentIcon)<{ isanimated: boolean }>`
  animation: ${(props) => (props.isanimated ? 'spin 0.75s linear infinite' : '')};
  @keyframes spin {
    100% {
      transform: rotate(360deg);
    }
  }
`

type Props = { uuid: string }

const Rebuild: React.FC<Props> = ({ uuid }) => {
  const t = useSelector((s) => s[props.TRANSLATION])
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const rebuildAnalysis = functional.use(Routes.REBUILD_SURVEY_ANALYSIS)
  const toast = useToast()

  const rebuild = async () => {
    setIsLoading(true)
    const response = await rebuildAnalysis({ surveyUUID: uuid })
    if (!!response) {
      toast(t.survey.analysis.rebuild.success, Type.SUCCESS)
    } else {
      toast(t.survey.analysis.rebuild.error)
    }
    setIsLoading(false)
  }

  return (
    <Tooltip text={t.survey.analysis.rebuild.tooltip}>
      <Icon isanimated={isLoading} className="text-blue w-5 cursor-pointer" onClick={rebuild} />
    </Tooltip>
  )
}

export default Rebuild
